<template>
  <div id="AdminDataFixer" v-if="this.userData.data.username=='admin'">
    <div v-show="loader">
      <Loader />
    </div>
    <div class="datepickerwrap">
      <div class="leftcontent wrapitem">  
        <div class="datebox" style="min-width:17%">
          <select class="form-control text-uppercase">
          	 <optgroup label="Retail">
              <option value="all">All</option>
              <option value="https://www.amazon.com">Amazon US</option>
              <option value="https://www.amazon.fr">Amazon France</option>
              <option value="https://www.amazon.co.it">Amazon Italy</option>
              <option value="https://www.amazon.es">Amazon Spain</option>
              <option value="https://www.amazon.co.uk">Amazon UK</option>
              <option value="https://www.amazon.de">Amazon Germany</option>
              <option value="https://www.bestbuy.com">Best Buy US</option>
              <option value="https://www.newegg.com">Newegg</option>
              <option value="https://www.microcenter.com">Microcenter</option>
              <option value="https://www.costco.com">Costco US</option>
              <option value="https://www.currys.co.uk">Curry's UK</option>
              <option value="https://www.harveynorman.com.au">Harvey Norman AU</option>  
              <option value="https://global.jd.com">JD GC</option>
              <option value="https://www.mediamarkt.de">MediaMarkt DE</option>
              <option value="https://www.walmart.com">Walmart US</option>
            </optgroup>
            <optgroup label="Consumer OEM">
              <option value="https://br-store.acer.com">Acer Brazil</option>
              <option value="https://store.acer.com/en-us">Acer US</option>
            	<option value="https://www.asus.com/fr">ASUS France</option>
            	<option value="https://store.asus.com/us">ASUS US</option>
              <option value="https://www.asus.com">ASUS WW</option>
              <option value="https://www.dell.com/en-au">Dell Australia</option>
              <option value="https://www.dell.com/ja-jp">Dell Japan</option>
              <option value="https://www.dell.com/en-us">Dell US</option>
              <option value="https://fmv.fccl.fujitsu.com">Fujitsu Japan</option>
              <option value="https://store.hp.com/FranceStore">HP France</option>
              <option value="https://www8.hp.com/jp">HP Japan</option>
              <option value="https://store.hp.com/mx-es">HP Mexico</option>
              <option value="https://store.hp.com/UKStore">HP UK</option>
              <option value="https://store.hp.com/us">HP US</option>
              <option value="https://www.lenovo.com/au">Lenovo Australia</option>
              <option value="https://s.lenovo.com.cn">Lenovo China</option>
              <option value="https://www.lenovo.com/fr">Lenovo France</option>
              <option value="https://www.lenovo.com/de">Lenovo Germany</option>
              <option value="https://www.lenovo.com/gb">Lenovo UK</option>
              <option value="https://www.lenovo.com/us">Lenovo US</option>
              <option value="https://www.nec-lavie.jp">NEC Japan</option>
            </optgroup>
            <optgroup label="Commercial OEM">
              <option value="https://www.hpstore.cn#commercial">Commercial HP China</option>
              <option value="https://store.hp.com/FranceStore#commercial">Commercial HP France</option>
              <option value="https://store.hp.com/GermanyStore#commercial">Commercial HP Germany</option>
              <option value="https://www8.hp.com/jp#commercial">Commercial HP Japan</option>
              <option value="https://store.hp.com/UKStore#commercial">Commercial HP UK</option>
              <option value="https://store.hp.com/us#commercial">Commercial HP US</option>
              <option value="https://b2b.lenovo.com.cn#commercial">Commercial Lenovo China</option>
              <option value="https://www.lenovo.com/fr#commercial">Commercial Lenovo France</option>
              <option value="https://www.lenovo.com/de#commercial">Commercial Lenovo Germany</option>
              <option value="https://www.lenovo.com/jp#commercial">Commercial Lenovo Japan</option>
              <option value="https://www.lenovo.com/gb#commercial">Commercial Lenovo UK</option>
              <option value="https://www.lenovo.com/us#commercial">Commercial Lenovo US</option>
            </optgroup>
            <optgroup label="Commercial Reseller">
              <option value="https://www.bechtle.com">Bechtle</option>
              <option value="https://www.cdw.com">CDW</option>
              <option value="https://www.inmac-wstore.com">Inmac</option>
              <option value="https://www.insight.com/en-US">Insight</option>
              <option value="https://www.connection.com">PC Connection</option>
              <option value="https://www.shi.com">SHI</option>
              <option value="https://www.technoworld.com">TechnoWorld</option>

            </optgroup>
          </select>
        </div>
      </div>
    </div>    
    <div class="container-fluid" >
      <div style="margin-top:10px">
        <b-card no-body>
          <b-tabs pills card>
            <b-tab title="ES -> ES" active>
              <b-card-text>
                <div class="space-between-header"> 
                  <h4 >Source</h4>
                </div>
                <div>
                  <div class="datebox">
                    <datepicker @input="refresh" v-model="date" />     
                  </div>
                  <div class="datebox">
                    <select class="form-control text-uppercase">
                      <option value="laptop">Laptop PC</option>
                      <option value="desktop">Desktop</option>
                    </select>
                  </div>  
                  <div class="datebox">
                    <select class="form-control text-uppercase">
                      <option value="laptop">Section</option>
                      <option value="desktop">Desktop</option>
                    </select>
                  </div>  
                  <div class="datebox">
                    <select class="form-control text-uppercase">
                      <option value="laptop">Segment</option>
                      <option value="desktop">Desktop</option>
                    </select>
                  </div>  
                </div>
                <hr>
                <div class="space-between-header"> 
                  <h4 >Target</h4>
                </div>
                <div>
                  <div class="datebox">
                    <datepicker @input="refresh" v-model="date" />     
                  </div>
                  <div class="datebox">
                    <datepicker @input="refresh" v-model="date" />     
                  </div>
                  <div class="datebox">
                    <select class="form-control text-uppercase">
                      <option value="laptop">Laptop PC</option>
                      <option value="desktop">Desktop</option>
                    </select>
                  </div>  
                  <div class="datebox">
                    <select class="form-control text-uppercase">
                      <option value="laptop">Section</option>
                      <option value="desktop">Desktop</option>
                    </select>
                  </div>  
                  <div class="datebox">
                    <select class="form-control text-uppercase">
                      <option value="laptop">Segment</option>
                      <option value="desktop">Desktop</option>
                    </select>
                  </div>  
                  <div style="margin-top:20px">
                    <button class="btn btn-success">Copy</button>
                  </div>
                </div>
                  
              </b-card-text>
            </b-tab>
            <b-tab title="Mongo -> ES">
              <b-card-text>
                <div class="space-between-header"> 
                  <h4 >Source</h4>
                </div>
                <div>
                  <div class="datebox">
                    <datepicker @input="refresh" v-model="date" />     
                  </div>
                  <div class="datebox">
                    <select class="form-control text-uppercase">
                      <option value="laptop">Laptop PC</option>
                      <option value="desktop">Desktop</option>
                    </select>
                  </div>  
                  <div class="datebox">
                    <select class="form-control text-uppercase">
                      <option value="laptop">Section</option>
                      <option value="desktop">Desktop</option>
                    </select>
                  </div>  
                  <div class="datebox">
                    <select class="form-control text-uppercase">
                      <option value="laptop">Segment</option>
                      <option value="desktop">Desktop</option>
                    </select>
                  </div>  
                </div>
                <hr>
                <div class="space-between-header"> 
                  <h4 >Target</h4>
                </div>
                <div>
                  <div class="datebox">
                    <datepicker @input="refresh" v-model="date" />     
                  </div>
                  <div class="datebox">
                    <datepicker @input="refresh" v-model="date" />     
                  </div>
                  <div class="datebox">
                    <select class="form-control text-uppercase">
                      <option value="laptop">Laptop PC</option>
                      <option value="desktop">Desktop</option>
                    </select>
                  </div>  
                  <div class="datebox">
                    <select class="form-control text-uppercase">
                      <option value="laptop">Section</option>
                      <option value="desktop">Desktop</option>
                    </select>
                  </div>  
                  <div class="datebox">
                    <select class="form-control text-uppercase">
                      <option value="laptop">Segment</option>
                      <option value="desktop">Desktop</option>
                    </select>
                  </div>  
                  <div style="margin-top:20px">
                    <button class="btn btn-success">Copy</button>
                  </div>
                </div>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
  
</template>

<script> 

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import Loader from '../Components/Loader.vue';
export default {
  name: 'AdminDataFixer',
  components: {
    Datepicker,
    Loader
  },

  data: function () {
    return {
      moment: moment,
      userData: JSON.parse(localStorage.getItem('reviewUserData')),
      date: moment().format('YYYY-MM-DD')
    }
  },
  mounted()
  { 
    this.refresh()

  },
  methods: {
    refresh(){

    }
  }
}

</script>

<style scoped>
  
</style>
